import {
    FETCH_COMPANY_BUDGET_GROUPS,
    SAVE_BUDGET_GROUP,
    DELETE_BUDGET_GROUP,
    CHANGE_BUDGET_LOAD_DATE,
    LOAD_BUDGET,
    START_BUDGET_LOAD,
    CANCEL_BUDGET_LOAD,
    FETCH_MONTHLY_BUDGET_BREAKDOWN
} from '../types';
import api from '../api';
import { fetchWorkers } from './WorkersActions';
import { getCurrentPeriod } from '../../helpers/company';

export const fetchCompanyBudgetGroups = (companyId) => {
    return {
        type: FETCH_COMPANY_BUDGET_GROUPS,
        payload: api.company.get(companyId).budget.groups.getAll(),
    };
};

export const saveBudgetGroup = (companyId, group) => {
    if (group.id) {
        return {
            type: SAVE_BUDGET_GROUP,
            payload: api.company.get(companyId).budget.groups.update(group),
            meta: { groupId: group.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_BUDGET_GROUP,
            payload: api.company.get(companyId).budget.groups.create(group),
            meta: { toastSuccess: true }
        };
    }
};

export const deleteBudgetGroup = (companyId, groupId) => {
    return {
        type: DELETE_BUDGET_GROUP,
        payload: api.company.get(companyId).budget.groups.delete(groupId),
        meta: { groupId, toastSuccess: true }
    };
};

export const startBudgetLoad = (monthlyCycleStartDay) => {
    const period = getCurrentPeriod(monthlyCycleStartDay);
    const possibleDates = [period[0], period[1]];
    const dateSelection = 0;

    return {
        type: START_BUDGET_LOAD,
        payload: { possibleDates, dateSelection },
    };
};

export const cancelBudgetLoad = () => {
    return { type: CANCEL_BUDGET_LOAD };
};

export const editBudgetLoad = (key, value) => {
    return {
        type: CHANGE_BUDGET_LOAD_DATE,
        payload: { key, value },
    };
};

export const calcLoadBudget = (companyId, date) => {
    return {
        type: LOAD_BUDGET,
        payload: api.company.get(companyId).budget.calc({ date }),
        meta: { calcOnly: true }
    };
};

export const loadBudget = (companyId, date, payment) => {
    return {
        type: LOAD_BUDGET,
        payload: api.company.get(companyId).budget.load({ date, payment }),
        meta: {
            calcOnly: false,
            toastSuccess: true,
            dispatchOnSuccess: () => fetchWorkers(companyId),
        }
    };
};

export const fetchMonthlyBreakdown = (companyId, date) => {
    return {
        type: FETCH_MONTHLY_BUDGET_BREAKDOWN,
        payload: api.company.get(companyId).budget.breakdown({ date })
    };
};